import { __rest, __assign, __awaiter, __generator } from '../../node_modules/tslib/tslib.es6.js';
import _get from 'lodash/get';
import _orderBy from 'lodash/orderBy';
import { useState, useRef, useEffect } from 'react';
import { useDelayedRedirect } from './useDelayedRedirect.js';

var useJoinBrandClub = function (brand, handleJoinClub) {
    var _a = useState((brand === null || brand === void 0 ? void 0 : brand.isMember) ? 'joined' : 'not_join'), joinedState = _a[0], setJoinedState = _a[1];
    var campaignRewards = _orderBy(_get(brand, ['campaignRewards']), ['rewardAmount'], ['desc']);
    var handleJoinError = function (errorMessage) {
        console.error('join club error: ', errorMessage);
        setJoinedState('not_join');
    };
    var handleJoin = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var campaignId, res, e_1;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!(brand === null || brand === void 0 ? void 0 : brand.brandclubId)) {
                        handleJoinError('brandclubId is not defined');
                        return [2 /*return*/];
                    }
                    (_a = e === null || e === void 0 ? void 0 : e.stopPropagation) === null || _a === void 0 ? void 0 : _a.call(e);
                    (_b = e === null || e === void 0 ? void 0 : e.preventDefault) === null || _b === void 0 ? void 0 : _b.call(e);
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, , 4]);
                    setJoinedState('joining');
                    campaignId = _get(campaignRewards, ['0', 'campaignId'], undefined);
                    return [4 /*yield*/, (handleJoinClub === null || handleJoinClub === void 0 ? void 0 : handleJoinClub(brand.brandclubId, campaignId))];
                case 2:
                    res = _c.sent();
                    if (res === 'success') {
                        setJoinedState('joined');
                    }
                    else {
                        handleJoinError('Unknown error');
                    }
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _c.sent();
                    if (e_1 instanceof Error) {
                        handleJoinError(e_1.message);
                    }
                    else {
                        handleJoinError('Unknown error');
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return {
        joinedState: joinedState,
        handleJoin: handleJoin,
        campaignRewards: campaignRewards,
    };
};
var useJoinBrandClubWithRedirect = function (_a) {
    var brand = _a.brand, handleJoinClub = _a.handleJoinClub, link = _a.link, _b = _a.delay, delay = _b === void 0 ? 500 : _b, navigate = _a.navigate;
    var _c = useJoinBrandClub(brand, handleJoinClub), joinedState = _c.joinedState, handleJoin = _c.handleJoin, rest = __rest(_c, ["joinedState", "handleJoin"]);
    var prevJoinedStateRef = useRef(joinedState);
    var delayedRedirect = useDelayedRedirect(navigate, delay);
    var brandId = brand === null || brand === void 0 ? void 0 : brand.brandId;
    useEffect(function () {
        // only redirect if we went from joining to joined
        if (brandId && prevJoinedStateRef.current === 'joining' && joinedState === 'joined') {
            delayedRedirect(link || "/joinclubsuccess/".concat(brandId));
        }
        prevJoinedStateRef.current = joinedState;
    }, [joinedState, delayedRedirect, link, brandId]);
    return __assign({ joinedState: joinedState, handleJoin: handleJoin }, rest);
};

export { useJoinBrandClub, useJoinBrandClubWithRedirect };
//# sourceMappingURL=useJoinBrandClub.js.map
